"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Merges two FileList objects and returns a new FileList object
 * @param fileListA The first FileList object
 * @param fileListB The second FileList object
 */
var mergeFileLists = function (fileListA, fileListB) {
    var dataTransfer = new DataTransfer();
    for (var i = 0; i < fileListA.length; i++) {
        dataTransfer.items.add(fileListA[i]);
    }
    for (var i = 0; i < fileListB.length; i++) {
        dataTransfer.items.add(fileListB[i]);
    }
    return dataTransfer.files;
};
exports.default = mergeFileLists;
